export default "__VITE_ASSET__d6PoLJOy__"